import { SET_USER_PLANT, SET_USER_DETAIL, SET_PLANT_HOST, DRAW_RECORD_DATA } from './types';
import { errHandler, getHost } from '@kk-activity-factory/utils';

const HOST = getHost();

export default {
    getFriendPlantAction({ commit }, params = {}) {
        const { friendUserId } = params;
        return request({
            url: HOST + '/gamecard/v2/friends/plant',
            data: { friendUserId },
            type: 'GET',
        })
            .then(({ data }) => {
                const { social = {}, host } = data;
                const { userDetail = {} } = social;

                commit({ type: SET_USER_PLANT, data: { ...data } });

                commit({ type: SET_PLANT_HOST, data: host });

                commit({ type: SET_USER_DETAIL, data: userDetail });
                return data;
            })
            .catch(errHandler);
    },
    drawCardWishRecordAct({ commit }, params) {
        return request({
            url: HOST + '/gamecard/v2/friends/drawCard/activities',
            data: params,
            type: 'GET',
        })
            .then(({ data }) => {
                commit({ type: DRAW_RECORD_DATA, data: data });
                return data;
            })
            .catch(errHandler);
    },
};
